import React from 'react';
import { Loader } from 'lucide-react';

export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-primary-50">
      <div className="bg-white p-8 rounded-xl shadow-md flex flex-col items-center">
        <Loader className="h-12 w-12 text-indigo-600 animate-spin mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Carregando...</h2>
        <p className="text-gray-600">Preparando seu dashboard</p>
      </div>
    </div>
  );
}